import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { useAmbienteContext } from '../../../context/ambienteContext'
import { onlyNumberWithDecimal } from '../../../components/functions'
import api from '../../../components/api'
import moment from 'moment'
import { useTabelaGestao } from '../../../context/GestaoPendenciasContext'

const Modal = (props) => {

    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    const energia_id = props.energia_id
    const ano = props.ano
    const adesao_institucional_id = props.adesao_institucional_id

    const { energiaAmbiente_id, setEnergiaAmbiente_id } = useAmbienteContext()



    var [identificacao, setIdentificacao] = useState('')
    var [tipoClimatizacao, setTipoClimatizacao] = useState('')
    var [area, setArea] = useState()
    var [horasDia, setHorasDia] = useState()
    var [diasAno, setDiasAno] = useState()

    var [lampLED, setLampLED] = useState(false)
    var [lampFluo, setLampFluo] = useState(false)
    var [lampIncand, setLampIncand] = useState(false)
    var [lampVapor, setLampVapor] = useState(false)

    var [lampLEDPerc, setLampLEDPerc] = useState('')
    var [lampFluoPerc, setLampFluoPerc] = useState('')
    var [lampIncandPerc, setLampIncandPerc] = useState('')
    var [lampVaporPerc, setLampVaporPerc] = useState('')

    var [tipoSistemaCentral, setTipoSistemaCentral] = useState(false)
    var [tipoSistemaUnitario, setTipoSistemaUnitario] = useState(false)
    var [tipoSistemaCentralPerc, setTipoSistemaCentralPerc] = useState('')
    var [tipoSistemaUnitarioPerc, setTipoSistemaUnitarioPerc] = useState('')



    function apagaAmbiente() {


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma a exclusão?',
		    buttons: {
		        Sim: function () {


                    api.delete(`energiaAmbiente/${energiaAmbiente_id}`).then((result) => {

                        //console.log(result.data)
                        //handleClose()
                        //carregaAmbientes()
                        window.$('#modalAmbiente').modal('hide')
                        window.toastr.success('Registro salvo com sucesso!')
                        setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                    }).catch((err) => {

                        console.log(err.response)

                    })

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }



    function salvaAmbiente() {

        
        if (identificacao == '') {

            window.toastr.error('<b>Identificação</b> n&atilde;o pode ficar em branco!')
            return false

        }

        
        if (tipoClimatizacao == '') {

            //window.toastr.error('<b>Tipo de climatização</b> n&atilde;o pode ficar em branco!')
            //return false

        }


        if (area == '') {

            //window.toastr.error('<b>Área [m<sup>2</sup>]</b> n&atilde;o pode ficar em branco!')
            //return false

        } else {


            if (area == '0') {

                //window.toastr.error('<b>Área [m<sup>2</sup>]</b> n&atilde;o pode ser igual a zero!')
                //return false

            }

        }

        if (horasDia == '') {

            //window.toastr.error('<b>Horas/Dia</b> n&atilde;o pode ficar em branco!')
            //return false

        } else {

            if (parseInt(horasDia) > 24) {

                //window.toastr.error('<b>Horas/Dia</b> n&atilde;o pode ser maior que 24!')
                //return false

            } else {

                if (parseInt(horasDia) == 0) {

                    //window.toastr.error('<b>Horas/Dia</b> n&atilde;o pode ser igual a zero!')
                    //return false

                }

            }

        }


        if (diasAno == '') {

            window.toastr.error('<b>Dias/Ano</b> n&atilde;o pode ficar em branco!')
            return false

        } else {

            if (parseInt(diasAno) > 365) {

                window.toastr.error('<b>Dias/Ano</b> n&atilde;o pode ser maior que 365!')
                return false

            } else {

                if (parseInt(diasAno) == 0) {

                    window.toastr.error('<b>Dias/Ano</b> n&atilde;o pode ser igual a zero!')
                    return false

                }

            }

        }



        switch (tipoClimatizacao) {

            case 'C':
                var tipoClimatizacaoDescri = 'Climatizado Interno - Conforto'
                break

            case 'E':
                var tipoClimatizacaoDescri = 'Climatizado Interno - Especial'
                break


        }

        var tipoLampadaDescri = ''
        
        if (lampLED) {

            var tipoLampadaDescri = 'LED '
            if (lampLEDPerc != '') { tipoLampadaDescri = tipoLampadaDescri + '[' + lampLEDPerc + '%]' }

            if (lampLED == true) {


                if (lampLEDPerc == '' || lampFluoPerc == null) {

                    //window.toastr.error('Por favor, informe o percentual de lâmpada do tipo <b>LED</b>')
                    //return false

                }
                

            }

        }

        if (lampFluo) {

            if (tipoLampadaDescri != '') { tipoLampadaDescri = tipoLampadaDescri + '; '}
            var tipoLampadaDescri = tipoLampadaDescri + 'Fluorescente '
            if (lampFluoPerc != '') { tipoLampadaDescri = tipoLampadaDescri + '[' + lampFluoPerc + '%]' }


            if (lampFluo == true) {

                if (lampFluoPerc == '' || lampFluoPerc == null) {

                    //window.toastr.error('Por favor, informe o percentual de lâmpada do tipo <b>Fluorescente</b>')
                    //return false

                }
                
            }

        }

        if (lampIncand) {

            if (tipoLampadaDescri != '') { tipoLampadaDescri = tipoLampadaDescri + '; '}
            var tipoLampadaDescri = tipoLampadaDescri + 'Incandescente '
            if (lampIncandPerc != '') { tipoLampadaDescri = tipoLampadaDescri + '[' + lampIncandPerc + '%]' }

            if (lampIncand == true) {

                if (lampIncandPerc == '' || lampIncandPerc == null) {

                    //window.toastr.error('Por favor, informe o percentual de lâmpada do tipo <b>Incandescente</b>')
                    //return false

                }
                
            }

        }


        if (lampVapor) {

            if (tipoLampadaDescri != '') { tipoLampadaDescri = tipoLampadaDescri + '; '}
            var tipoLampadaDescri = tipoLampadaDescri + 'Vapor Metálico '
            if (lampVaporPerc != '') { tipoLampadaDescri = tipoLampadaDescri + '[' + lampVaporPerc + '%]' }

            if (lampVapor == true) {

                if (lampVaporPerc == '' || lampVaporPerc == null) {

                    //window.toastr.error('Por favor, informe o percentual de lâmpada do tipo <b>Vapor metálico</b>')
                    //return false

                }
                
            }

        }



        var tipoSistemaDescri = ''


        if (tipoSistemaCentral == true) {

            if (tipoSistemaDescri != '') { tipoSistemaDescri = tipoSistemaDescri + '; '}
            var tipoSistemaDescri = tipoSistemaDescri + 'Central '
            if (tipoSistemaCentralPerc != '') { tipoSistemaDescri = tipoSistemaDescri + '[' + tipoSistemaCentralPerc + '%]' }


            if (tipoSistemaCentral == true) {

                if (tipoSistemaCentralPerc == '' || tipoSistemaCentralPerc == null) {

                    //window.toastr.error('Por favor, informe o percentual de <b>Tipo de Sistema Central</b>')
                    //return false

                }
                
            }

        }

        
        if (tipoClimatizacao != 'Não Climatizado - Externo' && tipoClimatizacao != 'Não Climatizado - Interno') {

            

            if (tipoSistemaCentral == false && tipoSistemaUnitario == false) {

                //window.toastr.error('Para este tipo de climatização por favor informe ao menos um tipo de sistema!')
                //return false

            }

        } else {

            setTipoSistemaCentral(false)
            setTipoSistemaCentralPerc('')
            setTipoSistemaUnitario(false)
            setTipoSistemaUnitarioPerc('')

        }


        if (tipoSistemaUnitario) {

            if (tipoSistemaDescri != '') { tipoSistemaDescri = tipoSistemaDescri + '; '}
            var tipoSistemaDescri = tipoSistemaDescri + 'Unitário '
            if (tipoSistemaUnitarioPerc != '') { tipoSistemaDescri = tipoSistemaDescri + '[' + tipoSistemaUnitarioPerc + '%]' }


            if (tipoSistemaUnitario == true) {

                if (tipoSistemaUnitarioPerc == '' || tipoSistemaUnitarioPerc == null) {

                    //window.toastr.error('Por favor, informe o percentual de <b>Tipo de Sistema Unitário</b>')
                    //return false

                }
                
            }


        }


        var possuiIluminacao = false

        if (lampFluo == true || lampLED == true || lampIncand == true || lampVapor == true) {

            var possuiIluminacao = true


            var lampFluoPerc_c = lampFluoPerc == null || lampFluoPerc == '' ? 0 : parseInt(lampFluoPerc)
            var lampLEDPerc_c = lampLEDPerc == null || lampLEDPerc == '' ? 0 : parseInt(lampLEDPerc)
            var lampIncandPerc_c = lampIncandPerc == null || lampIncandPerc == '' ? 0 : parseInt(lampIncandPerc)
            var lampVaporPerc_c = lampVaporPerc == null || lampVaporPerc == '' ? 0 : parseInt(lampVaporPerc)

            var totalLampPerc = parseInt(lampFluoPerc_c) + parseInt(lampLEDPerc_c) + parseInt(lampIncandPerc_c) + parseInt(lampVaporPerc_c)

            if (totalLampPerc != 100) {

                //window.toastr.error('A soma dos percentuais dos tipos de lâmpadas precisa ser igual a 100%!')
                //return false

            }


        }


        if (tipoClimatizacao != 'Não Climatizado - Externo') {

            /*
            console.log(lampFluo)
            console.log(lampLED)
            console.log(lampIncand)
            console.log(lampVapor)
            */

            if (!lampFluo && !lampLED && !lampIncand && !lampVapor) {


                //window.toastr.error('Por favor, para este tipo de climatização informe ao menos um tipo de lâmpada!')
                //return false

            }


        }


        var possuiClimatizacao = false


        if (tipoSistemaCentral == true || tipoSistemaUnitario == true) {

            var possuiClimatizacao = true


            var tipoSistemaCentralPerc_c = tipoSistemaCentralPerc == null || tipoSistemaCentralPerc == '' ? 0 : parseInt(tipoSistemaCentralPerc)
            var tipoSistemaUnitarioPerc_c = tipoSistemaUnitarioPerc == null || tipoSistemaUnitarioPerc == '' ? 0 : parseInt(tipoSistemaUnitarioPerc)
            

            var totalTipoSistemaPerc = parseInt(tipoSistemaCentralPerc_c) + parseInt(tipoSistemaUnitarioPerc_c)

            if (totalTipoSistemaPerc != 100) {

                //window.toastr.error('A soma dos percentuais dos tipos de sistemas de climatização precisa ser igual a 100%!')
                //return false

            }


        }


        



        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma a inclusão?',
		    buttons: {
		        Sim: function () {



            
            
                    //console.log(itemTemp)

                    if (energiaAmbiente_id) {


                        var dataPost = {

                            energia_id: energia_id,
                            chave: uuidv4(),
                            identificacao: identificacao.toUpperCase(),
                            tipoClimatizacao: tipoClimatizacao,
                            energia_id: energia_id,
                            adesao_institucional_id: adesao_institucional_id,
                            ano: ano,
                            //tipoClimatizacaoDescri: tipoClimatizacaoDescri,
                            area: area,
                            horasDia: horasDia,
                            lampLED: lampLED,
                            lampFluo: lampFluo,
                            lampIncand: lampIncand,
                            lampVapor: lampVapor,
                            lampLEDPerc: lampLEDPerc,
                            lampFluoPerc: lampFluoPerc,
                            lampIncandPerc: lampIncandPerc,
                            lampVaporPerc: lampVaporPerc,
                            tipoSistemaCentral: tipoSistemaCentral,
                            tipoSistemaUnitario: tipoSistemaUnitario,
                            tipoSistemaCentralPerc: tipoSistemaCentralPerc,
                            tipoSistemaUnitarioPerc: tipoSistemaUnitarioPerc,
                
                            tipoLampadaDescri: tipoLampadaDescri,
                            tipoSistemaDescri: tipoSistemaDescri,
                            diasAno: diasAno,
                            
                
                        }

                        api.put(`energiaAmbiente/${energiaAmbiente_id}`, dataPost).then((result) => {

                            //console.log(result.data)
                            //handleClose()
                            //carregaAmbientes()
                            window.$('#modalAmbiente').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

                            var mensagem = ''

                            if (possuiIluminacao == true || possuiClimatizacao == true) {


                                if (possuiIluminacao == true) {

                                    var mensagem = 'Por favor, reportar Lâmpadas na aba <b>iluminação</b>.'

                                }

                                if (possuiClimatizacao == true && tipoClimatizacao != 'Não Climatizado - Interno' && tipoClimatizacao != 'Não Climatizado - Externo') {

                                    if (mensagem != '') { mensagem = `${mensagem}<br><br>` }

                                    var mensagem = mensagem + 'Por favor, reportar Equipamentos e/ou Sistema de Climatização na aba <b>HVAC</b>.'

                                }

                                
                                window.$.confirm({
                                    //icon: 'fa fa-question',
                                    theme: 'material',
                                    closeIcon: true,
                                    animation: 'scale',
                                    type: 'orange',
                                    title: 'Importante',
                                    content: mensagem,
                                    buttons: {
                                        Entendi: function () {

                                        },                                       
                        
                                    },
                        
                                });

                            }
                                



                        }).catch((err) => {

                            console.log(err.response)

                        })

                    } else {




                        var dataPost = {

                            chave: uuidv4(),
                            identificacao: identificacao,
                            tipoClimatizacao: tipoClimatizacao,
                            energia_id: energia_id,
                            adesao_institucional_id: adesao_institucional_id,
                            ano: ano,
                            //tipoClimatizacaoDescri: tipoClimatizacaoDescri,
                            area: area,
                            horasDia: horasDia,
                            lampLED: lampLED,
                            lampFluo: lampFluo,
                            lampIncand: lampIncand,
                            lampVapor: lampVapor,
                            lampLEDPerc: lampLEDPerc,
                            lampFluoPerc: lampFluoPerc,
                            lampIncandPerc: lampIncandPerc,
                            lampVaporPerc: lampVaporPerc,
                            tipoSistemaCentral: tipoSistemaCentral,
                            tipoSistemaUnitario: tipoSistemaUnitario,
                            tipoSistemaCentralPerc: tipoSistemaCentralPerc,
                            tipoSistemaUnitarioPerc: tipoSistemaUnitarioPerc,
                
                            tipoLampadaDescri: tipoLampadaDescri,
                            tipoSistemaDescri: tipoSistemaDescri,
                            diasAno: diasAno,
                            
                
                        }

                        api.post(`energiaAmbiente`, dataPost).then((result) => {

                            //console.log(result.data)
                            //if (result.data.status == 'ok') {
    
                                //console.log(result.data)
                                //handleClose()
                                //carregaAmbientes()

                                window.$('#modalAmbiente').modal('hide')
                                window.toastr.success('Registro salvo com sucesso!')
                                setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))


                                var mensagem = ''

                                if (possuiIluminacao == true || possuiClimatizacao == true) {


                                    if (possuiIluminacao == true) {

                                        var mensagem = 'Por favor, reportar Lâmpadas na aba <b>iluminação</b>.'

                                    }

                                    if (possuiClimatizacao == true) {

                                        if (mensagem != '') { mensagem = `${mensagem}<br><br>` }

                                        var mensagem = mensagem + 'Por favor, reportar Equipamentos e/ou Sistema de Climatização na aba <b>HVAC</b>.'

                                    }

                                    
                                    window.$.confirm({
                                        //icon: 'fa fa-question',
                                        theme: 'material',
                                        closeIcon: true,
                                        animation: 'scale',
                                        type: 'orange',
                                        title: 'Importante',
                                        content: mensagem,
                                        buttons: {
                                            Entendi: function () {

                                            },                                       
                            
                                        },
                            
                                    });

                                }
                                
    
                            //}
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })

                    }

                    
            
            
                    /*
                    setItens([...itens, itemTemp])
                    */
            
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });





    }


    function carregaAmbienteDet() {

        if (energiaAmbiente_id) {

            api.get(`energiaAmbienteListaUm/${energiaAmbiente_id}`).then((result) => {

                //console.log(result.data)
                var data = result.data[0]

                setIdentificacao(data.identificacao)
                setTipoClimatizacao(data.tipoClimatizacao)
                setArea(data.area == null ? '' : data.area.toString())
                setHorasDia(data.horasDia == null ? '' : data.horasDia.toString())
                setDiasAno(data.diasAno == null ? '' : data.diasAno.toString())
                setLampFluo(data.lampFluo)
                setLampFluoPerc(data.lampFluoPerc == null ? '' : data.lampFluoPerc.toString())
                setLampLED(data.lampLED)
                setLampLEDPerc(data.lampLEDPerc == null ? '' : data.lampLEDPerc.toString())
                setLampIncand(data.lampIncand)
                setLampIncandPerc(data.lampIncandPerc == null ? '' : data.lampIncandPerc.toString())
                setLampVapor(data.lampVaporPerc)
                setLampVaporPerc(data.lampVaporPerc == null ? '' : data.lampVaporPerc.toString())
                setTipoSistemaCentral(data.tipoSistemaCentral)
                setTipoSistemaUnitario(data.tipoSistemaUnitario)
                setTipoSistemaCentralPerc(data.tipoSistemaCentralPerc == null ? '' : data.tipoSistemaCentralPerc.toString())
                setTipoSistemaUnitarioPerc(data.tipoSistemaUnitarioPerc == null ? '' : data.tipoSistemaUnitarioPerc.toString())

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }


    function limpaDados() {

        setIdentificacao('')
        setTipoClimatizacao('')
        setArea('')
        setHorasDia('')
        setDiasAno('')
        setLampLED(false)
        setLampFluo(false)
        setLampIncand(false)
        setLampVapor(false)
        setLampLEDPerc('')
        setLampFluoPerc('')
        setLampIncandPerc('')
        setLampVaporPerc('')
        setTipoSistemaCentral(false)
        setTipoSistemaCentralPerc('')
        setTipoSistemaUnitario(false)
        setTipoSistemaUnitarioPerc('')
    }

    
    const handleChange = (e) => {
        e.preventDefault();
    }



    useEffect(() => {

        limpaDados()
        carregaAmbienteDet()

    }, [energiaAmbiente_id])

    return (

        <div>

                <div className="modal fade" id="modalAmbiente" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Ambiente</h1>
                            </div>
                            <div className="modal-body">


                            <div className="row">

    
                                <div className="col-md-6" >
                                    <div class="form-group" >
                                        
                                        <label className="control-label">

                                        <span class="wrapper2">
                                            Identificação
                                            <div class="tooltip">
                                            insira um nome para identificar o "ambiente"
                                            </div>
                                        </span>

                                            
                                        </label>                                        
                                        <input type="text" class="form-control" onChange={event => setIdentificacao(event.target.value)} value={identificacao} style={{ textTransform: 'uppercase'}} />
                                            
                                    </div>
                                </div>

                                <div className="col-md-6" >
                                    <div class="form-group" >

                                        <label className="control-label">
                                        
                                            <span class="wrapper2">
                                                Tipo de Climatização *
                                                <div class="tooltip">
                                                selecione como o tipo de climatização, se houver, do "ambiente"
                                                </div>
                                            </span>

                                        </label>


                                        <select class="form-control" onChange={event => setTipoClimatizacao(event.target.value)} value={tipoClimatizacao} >
                                            <option value="">[Selecione]</option>
                                            <option value="Climatizado Interno - Especial">Climatizado Interno - Especial</option>
                                            <option value="Climatizado Interno - Conforto">Climatizado Interno - Conforto</option>
                                            <option value="Não Climatizado - Interno">Não Climatizado - Interno</option>
                                            <option value="Não Climatizado - Externo">Não Climatizado - Externo</option>
                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div class="form-group" >
                                        <br/>


                                        <label className="control-label">

                                            <span class="wrapper2">
                                                Área [m<sup>2</sup>] *
                                                <div class="tooltip">
                                                digite a área deste "ambiente" (apenas números com até 2 casas decimais). Ex.: para 1.250,45 m2 digite 1250,45
                                                </div>
                                            </span>

                                        </label>



                                        <input type="text" class="form-control" onChange={event => setArea(event.target.value)} value={area} 
                                        onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                        
                                        />
                                            
                                    </div>
                                </div>


                                <div className="col-md-4" >
                                    <div class="form-group" >
                                        <br/>
                                        

                                        <label className="control-label">

                                            <span class="wrapper2">
                                                Horas/dia *
                                                <div class="tooltip">
                                                insira quantas horas este "ambiente" funciona por dia (apenas número inteiro. Ex.: 24)
                                                </div>
                                            </span>

                                        </label>

                                        <input type="text" class="form-control" onChange={event => setHorasDia(event.target.value)} value={horasDia} 
                                        
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                            }
                                        }} />
                                            
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div class="form-group" >
                                        <br/>

                                        <label className="control-label">

                                            <span class="wrapper2">
                                                Dias/ano *
                                                <div class="tooltip">
                                                insira quantos dias este "ambiente" funciona por ano (apenas número inteiro. Ex.: 260)
                                                </div>
                                            </span>

                                        </label>

                                        <input type="text" class="form-control" onChange={event => setDiasAno(event.target.value)} value={diasAno} 
                                        
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                            }
                                        }} />
                                            
                                    </div>
                                </div>

                                
                                <div className="col-md-12" >
                                    <div class="form-group" >
                                    <br/>
                                    

                                        <label className="control-label">

                                            <span class="wrapper2">
                                                Tipo de Lâmpada
                                                <div class="tooltip">
                                                insira, aproximadamente, a porcentagem da área atendida por tipo de lâmpadas (apenas número inteiro. Ex.: LED: 80%, Fluorescente: 20%, Incandescente: 0%, Vapor metálico: 0%. Importante: a soma deve ser 100%)
                                                </div>
                                            </span>

                                        </label>

                                        <table style={{ 'border': 'hidden'}} width="100%">
                                            <tr>
                                                <td>
                                                    <input type="checkbox" onChange={event => setLampLED(event.target.checked)} checked={ lampLED == true ? true : false } />
                                                </td>
                                                <td>
                                                    LED
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" onChange={event => setLampLEDPerc(event.target.value)} value={lampLEDPerc} 
                                                    
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                        }
                                                    
                                                    }}                                                
                                                    placeholder="Informe o percentual"
                                                    disabled={ lampLED == true ? false : true }
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input type="checkbox"  onChange={event => setLampFluo(event.target.checked)} checked={ lampFluo == true ? true : false }  />
                                                </td>
                                                <td>
                                                    Fluorescente
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" onChange={event => setLampFluoPerc(event.target.value)} value={lampFluoPerc} 
                                                    
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                        }
                                                    }} 
                                                    placeholder="Informe o percentual"
                                                    disabled={ lampFluo == true ? false : true }
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input type="checkbox" onChange={event => setLampIncand(event.target.checked)} checked={ lampIncand == true ? true : false } />
                                                </td>
                                                <td>
                                                    Incandescente
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" onChange={event => setLampIncandPerc(event.target.value)} value={lampIncandPerc} 
                                                    
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                        }
                                                    }} 
                                                    placeholder="Informe o percentual"
                                                    disabled={ lampIncand == true ? false : true }
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input type="checkbox" onChange={event => setLampVapor(event.target.checked)} checked={ lampVapor == true ? true : false } />
                                                </td>
                                                <td>
                                                    Vapor metálico
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" onChange={event => setLampVaporPerc(event.target.value)} value={lampVaporPerc} 
                                                    
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                        }
                                                    }} 
                                                    placeholder="Informe o percentual"
                                                    disabled={ lampVapor == true ? false : true }
                                                    />
                                                </td>
                                            </tr>
                                        </table>

                                    </div>
                                </div>



                                <div className="col-md-12" style={{ display: tipoClimatizacao == 'Não Climatizado - Externo' || tipoClimatizacao == 'Não Climatizado - Interno' ? 'none' : 'table-row' }}>
                                    <div class="form-group" >
                                    <br/>

                                        <label className="control-label">

                                            <span class="wrapper2">
                                                Tipo de Sistema de Climatização
                                                <div class="tooltip">
                                                insira, aproximadamente, a porcentagem da área atendida por tipo de sistema de climatização (apenas número inteiro. Ex.: Central: 0%, Unitário: 0%. Importante: a soma deve ser 100%)
                                                </div>
                                            </span>

                                        </label>

                                    


                                        <table style={{ 'border': 'hidden'}} width="100%">
                                                <tr>
                                                    <td>
                                                        <input type="checkbox" onChange={event => setTipoSistemaCentral(event.target.checked)} checked={ tipoSistemaCentral == true ? true : false } />
                                                    </td>
                                                    <td>
                                                        Central
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control" onChange={event => setTipoSistemaCentralPerc(event.target.value)} value={tipoSistemaCentralPerc} 
                                                        
                                                        onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                            }
                                                        }} 
                                                        placeholder="Informe o percentual"
                                                        disabled={ tipoSistemaCentral == true ? false : true }
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <input type="checkbox" onChange={event => setTipoSistemaUnitario(event.target.checked)} checked={ tipoSistemaUnitario == true ? true : false }  />
                                                    </td>
                                                    <td>
                                                        Unitário
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control" onChange={event => setTipoSistemaUnitarioPerc(event.target.value)} value={tipoSistemaUnitarioPerc} 
                                                        
                                                        onKeyPress={(event) => {
                                                            if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                            }
                                                        }} 
                                                        placeholder="Informe o percentual"
                                                        disabled={ tipoSistemaUnitario == true ? false : true }
                                                        />
                                                    </td>
                                                    
                                                </tr>
                                                
                                            </table>

                                    
                                        </div>
                                </div>


                            


                                </div>
                                    

                            </div>
                            <div className="modal-footer">

                                <button type="button" className="btn btn-danger" onClick={() => apagaAmbiente()} style={{ display: energiaAmbiente_id ? 'table-row' : 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salvaAmbiente()}>Salvar</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}

export default Modal